import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SupervisedCallQueuesQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type SupervisedCallQueuesQuery = { __typename?: 'Query', userCapabilities?: Array<Types.Capability | null> | null, supervisedCallQueues: Array<{ __typename?: 'SupervisedCallQueueInfo', id: number, name: string, number: string }> };

export type PersonalExtensionCallListQueryVariables = Types.Exact<{
  extensionNumberId: Types.Scalars['Int']['input'];
}>;


export type PersonalExtensionCallListQuery = { __typename?: 'Query', callList: { __typename?: 'CallList', calls: Array<{ __typename?: 'Call', callId: string, callTime: any, connectTime: any, disconnectTime: any, connected: boolean, direction: string, duration: number, private: boolean, remoteE164: string, remoteNumber: string, remoteNumberId?: number | null, localNumber: string, localDomain: string, localE164: string, localNumberId?: number | null, originalCallingNumber?: string | null, originalCallingE164?: string | null, segmentType: Types.SegmentType, recordingId?: string | null, disconnectReason?: Types.DisconnectReason | null, onBehalfOf?: string | null }> } };

export type PersonalExtensionCallListVoicemailsQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type PersonalExtensionCallListVoicemailsQuery = { __typename?: 'Query', voicemails: { __typename?: 'VoicemailList', voicemails?: Array<{ __typename?: 'VoicemailEntry', callId: string, voicemailId: number, listened: boolean }> | null, errors?: Array<{ __typename?: 'Error', type: string }> | null } };

export type PersonalExtensionNumberIdQueryVariables = Types.Exact<{
  extensionId: Types.Scalars['Int']['input'];
}>;


export type PersonalExtensionNumberIdQuery = { __typename?: 'Query', users?: { __typename?: 'UserList', items: Array<{ __typename?: 'User', numberId: number } | null> } | null };


export const SupervisedCallQueuesDocument = gql`
    query SupervisedCallQueues($userId: Int!) {
  supervisedCallQueues(userId: $userId) {
    id
    name
    number
  }
  userCapabilities(userId: $userId)
}
    `;

/**
 * __useSupervisedCallQueuesQuery__
 *
 * To run a query within a React component, call `useSupervisedCallQueuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupervisedCallQueuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupervisedCallQueuesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSupervisedCallQueuesQuery(baseOptions: Apollo.QueryHookOptions<SupervisedCallQueuesQuery, SupervisedCallQueuesQueryVariables> & ({ variables: SupervisedCallQueuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupervisedCallQueuesQuery, SupervisedCallQueuesQueryVariables>(SupervisedCallQueuesDocument, options);
      }
export function useSupervisedCallQueuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupervisedCallQueuesQuery, SupervisedCallQueuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupervisedCallQueuesQuery, SupervisedCallQueuesQueryVariables>(SupervisedCallQueuesDocument, options);
        }
export function useSupervisedCallQueuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupervisedCallQueuesQuery, SupervisedCallQueuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupervisedCallQueuesQuery, SupervisedCallQueuesQueryVariables>(SupervisedCallQueuesDocument, options);
        }
export type SupervisedCallQueuesQueryHookResult = ReturnType<typeof useSupervisedCallQueuesQuery>;
export type SupervisedCallQueuesLazyQueryHookResult = ReturnType<typeof useSupervisedCallQueuesLazyQuery>;
export type SupervisedCallQueuesSuspenseQueryHookResult = ReturnType<typeof useSupervisedCallQueuesSuspenseQuery>;
export type SupervisedCallQueuesQueryResult = Apollo.QueryResult<SupervisedCallQueuesQuery, SupervisedCallQueuesQueryVariables>;
export const PersonalExtensionCallListDocument = gql`
    query PersonalExtensionCallList($extensionNumberId: Int!) {
  callList(numberId: $extensionNumberId) {
    calls {
      callId
      callTime
      connectTime
      disconnectTime
      connected
      direction
      duration
      private
      remoteE164
      remoteNumber
      remoteNumberId
      localNumber
      localDomain
      localE164
      localNumberId
      originalCallingNumber
      originalCallingE164
      segmentType
      recordingId
      disconnectReason
      onBehalfOf
    }
  }
}
    `;

/**
 * __usePersonalExtensionCallListQuery__
 *
 * To run a query within a React component, call `usePersonalExtensionCallListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalExtensionCallListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalExtensionCallListQuery({
 *   variables: {
 *      extensionNumberId: // value for 'extensionNumberId'
 *   },
 * });
 */
export function usePersonalExtensionCallListQuery(baseOptions: Apollo.QueryHookOptions<PersonalExtensionCallListQuery, PersonalExtensionCallListQueryVariables> & ({ variables: PersonalExtensionCallListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonalExtensionCallListQuery, PersonalExtensionCallListQueryVariables>(PersonalExtensionCallListDocument, options);
      }
export function usePersonalExtensionCallListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonalExtensionCallListQuery, PersonalExtensionCallListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonalExtensionCallListQuery, PersonalExtensionCallListQueryVariables>(PersonalExtensionCallListDocument, options);
        }
export function usePersonalExtensionCallListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonalExtensionCallListQuery, PersonalExtensionCallListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonalExtensionCallListQuery, PersonalExtensionCallListQueryVariables>(PersonalExtensionCallListDocument, options);
        }
export type PersonalExtensionCallListQueryHookResult = ReturnType<typeof usePersonalExtensionCallListQuery>;
export type PersonalExtensionCallListLazyQueryHookResult = ReturnType<typeof usePersonalExtensionCallListLazyQuery>;
export type PersonalExtensionCallListSuspenseQueryHookResult = ReturnType<typeof usePersonalExtensionCallListSuspenseQuery>;
export type PersonalExtensionCallListQueryResult = Apollo.QueryResult<PersonalExtensionCallListQuery, PersonalExtensionCallListQueryVariables>;
export const PersonalExtensionCallListVoicemailsDocument = gql`
    query PersonalExtensionCallListVoicemails($userId: Int!) {
  voicemails(userId: $userId) {
    voicemails {
      callId
      voicemailId
      listened
    }
    errors {
      type
    }
  }
}
    `;

/**
 * __usePersonalExtensionCallListVoicemailsQuery__
 *
 * To run a query within a React component, call `usePersonalExtensionCallListVoicemailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalExtensionCallListVoicemailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalExtensionCallListVoicemailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePersonalExtensionCallListVoicemailsQuery(baseOptions: Apollo.QueryHookOptions<PersonalExtensionCallListVoicemailsQuery, PersonalExtensionCallListVoicemailsQueryVariables> & ({ variables: PersonalExtensionCallListVoicemailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonalExtensionCallListVoicemailsQuery, PersonalExtensionCallListVoicemailsQueryVariables>(PersonalExtensionCallListVoicemailsDocument, options);
      }
export function usePersonalExtensionCallListVoicemailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonalExtensionCallListVoicemailsQuery, PersonalExtensionCallListVoicemailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonalExtensionCallListVoicemailsQuery, PersonalExtensionCallListVoicemailsQueryVariables>(PersonalExtensionCallListVoicemailsDocument, options);
        }
export function usePersonalExtensionCallListVoicemailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonalExtensionCallListVoicemailsQuery, PersonalExtensionCallListVoicemailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonalExtensionCallListVoicemailsQuery, PersonalExtensionCallListVoicemailsQueryVariables>(PersonalExtensionCallListVoicemailsDocument, options);
        }
export type PersonalExtensionCallListVoicemailsQueryHookResult = ReturnType<typeof usePersonalExtensionCallListVoicemailsQuery>;
export type PersonalExtensionCallListVoicemailsLazyQueryHookResult = ReturnType<typeof usePersonalExtensionCallListVoicemailsLazyQuery>;
export type PersonalExtensionCallListVoicemailsSuspenseQueryHookResult = ReturnType<typeof usePersonalExtensionCallListVoicemailsSuspenseQuery>;
export type PersonalExtensionCallListVoicemailsQueryResult = Apollo.QueryResult<PersonalExtensionCallListVoicemailsQuery, PersonalExtensionCallListVoicemailsQueryVariables>;
export const PersonalExtensionNumberIdDocument = gql`
    query PersonalExtensionNumberId($extensionId: Int!) {
  users(id: $extensionId) {
    items {
      numberId
    }
  }
}
    `;

/**
 * __usePersonalExtensionNumberIdQuery__
 *
 * To run a query within a React component, call `usePersonalExtensionNumberIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalExtensionNumberIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalExtensionNumberIdQuery({
 *   variables: {
 *      extensionId: // value for 'extensionId'
 *   },
 * });
 */
export function usePersonalExtensionNumberIdQuery(baseOptions: Apollo.QueryHookOptions<PersonalExtensionNumberIdQuery, PersonalExtensionNumberIdQueryVariables> & ({ variables: PersonalExtensionNumberIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonalExtensionNumberIdQuery, PersonalExtensionNumberIdQueryVariables>(PersonalExtensionNumberIdDocument, options);
      }
export function usePersonalExtensionNumberIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonalExtensionNumberIdQuery, PersonalExtensionNumberIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonalExtensionNumberIdQuery, PersonalExtensionNumberIdQueryVariables>(PersonalExtensionNumberIdDocument, options);
        }
export function usePersonalExtensionNumberIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonalExtensionNumberIdQuery, PersonalExtensionNumberIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonalExtensionNumberIdQuery, PersonalExtensionNumberIdQueryVariables>(PersonalExtensionNumberIdDocument, options);
        }
export type PersonalExtensionNumberIdQueryHookResult = ReturnType<typeof usePersonalExtensionNumberIdQuery>;
export type PersonalExtensionNumberIdLazyQueryHookResult = ReturnType<typeof usePersonalExtensionNumberIdLazyQuery>;
export type PersonalExtensionNumberIdSuspenseQueryHookResult = ReturnType<typeof usePersonalExtensionNumberIdSuspenseQuery>;
export type PersonalExtensionNumberIdQueryResult = Apollo.QueryResult<PersonalExtensionNumberIdQuery, PersonalExtensionNumberIdQueryVariables>;